export default __webpack_public_path__ + "static/media/img_industry_5.e95e09a7.png";